import Form from "../components/Form";

export default function Contact() {
    return (
        <main className="Contact">
            <header style={{ backgroundImage: `url('images/skyline2.png')` }} className='vertical-gradient texture1 header-alt' >
                <div class="glow-wrapper alt-head-txt">
                    <span class="glow-text">CONTACT</span>
                    <span class="stroke-text">CONTACT</span>
                </div>
            </header>
            <section id="contact-top">

                <br />
                <br />
                <br />

                <div className="line-style-2"></div>

                <div id="contactcards">
                    <div className="card contact-card-format">
                        <a className="contact-top-links" href="mailto: dawsonbolenwebdev@gmail.com">
                            <div className="contactlinks">
                                <div className="contactlinks-row1">
                                    <img src={process.env.PUBLIC_URL + "/images/emailicon.png"} width="100px" height="100px" alt="email icon"></img>
                                </div>
                                <div className="contactlinks-row2">
                                    <h2>Email</h2>
                                    <p>dawsonbolenwebdev@gmail.com</p>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="card contact-card-format">
                        <a className="contact-top-links" href="tel:4257499555">
                            <div className="contactlinks">
                                <div className="contactlinks-row1">
                                    <img src={process.env.PUBLIC_URL + "/images/smartphoneicon.png"} width="100px" height="100px" alt="phone icon"></img>
                                </div>
                                <div className="contactlinks-row2">
                                    <h2>Phone</h2>
                                    <p>425-749-9555</p>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="card contact-card-format">
                        <a class="contact-top-links" href="https://www.linkedin.com/in/dawsonbolen/">
                            <div className="contactlinks">
                                <div className="contactlinks-row1">
                                    <img src={process.env.PUBLIC_URL + "/images/linkedinicon.png"} width="100px" height="100px" alt="linkedin icon"></img>
                                </div>
                                <div className="contactlinks-row2">
                                    <h2>Linkedin</h2>
                                    <p>Dawson Bolen</p>
                                </div>
                            </div>
                        </a>
                    </div>

                </div>


            </section>

            <br />
            <br />

            <Form />
            <br />


        </main>
    );
}